import { ConditionDictionary, isIncrementalVariableValue, RequirementConfig, Requirements } from '@ca/common/types'
import validateCondition, { ValidationResult } from './validateCondition'
import { Refraction } from '@ca/common'
import { VariableValues } from './OrderVariables'

export type FailedRequirement = {
  variable: string
  check: string
  expectedValues: string[]
  actualValue: unknown
}

export type ItemValidationTrace = {
  result: boolean
  failedRequirement?: FailedRequirement
  condition?: ValidationResult
}

const checkRequirement = (req: RequirementConfig, values: VariableValues): boolean => {
  const value = values[req.config?.variable]
  if (!value) return req.check === 'none'
  const toCheck = `${value}`.toLowerCase()
  const isIncremental = isIncrementalVariableValue(value)
  const compare = (v: string) =>
    isIncremental ? toCheck.includes(v.toLowerCase()) : v.toLowerCase() === toCheck
  return req.check === 'none'
    ? !req.config.values.some(compare)
    : req.config.values.some(compare)
}

export const validateItem = (
  item: {
    requires: Requirements | null
    condition: string | null
  },
  values: VariableValues,
  conditions: ConditionDictionary,
  refraction: Refraction | undefined
): ItemValidationTrace => {
  if (item.requires) {
    for (const req of item.requires) {
      if (!checkRequirement(req, values)) {
        return {
          result: false,
          failedRequirement: {
            variable: req.config?.variable,
            check: req.check ?? 'any',
            expectedValues: req.config?.values ?? [],
            actualValue: values[req.config?.variable],
          },
        }
      }
    }
  }

  if (!item.condition) {
    return { result: true }
  }

  const condition = validateCondition(
    conditions[item.condition],
    { ...values, ref: refraction },
    conditions
  )

  return { result: condition.result, condition }
}
